import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';

export default withStyles({
    root: {
        width: '100%',
        zIndex: 'initial',
        // '& label[data-shrink=false] + .MuiInputBase-formControl .MuiInputBase-input::-webkit-input-placeholder': {
        '& label[data-shrink=false] + [class*="MuiInputBase-formControl"] [class*="MuiInputBase-input"]::-webkit-input-placeholder': {
            opacity: '.42 !important',
        },
        // '& .MuiInputBase-multiline': {
        '& [class*="MuiInputBase-multiline"]': {
            padding: 0,
        },
        // '& .MuiFormControlLabel-label': {
        '& [class*="FormControlLabel-label"]': {
            color: (props) => (props['data-error'] ? ['#f44336', '!important'] : 'rgba(0, 0, 0, 0.54)'),
            fontSize: 14,
        },
        // '& .MuiInputLabel-formControl': {
        '& [class*="MuiInputLabel-formControl"]': {
            color: (props) => (props['data-error'] ? ['#f44336', '!important'] : 'rgba(0, 0, 0, 0.54)'),
            position: 'initial',
            marginBottom: props => 8,
            fontSize: 14,
            
            // '&.Mui-focused': {
            '&[class*="Mui-focused"]': {
                color: '#3dbbe2',
            },
            // '&:not(.MuiInputLabel-shrink)': {
            '&:not([class*="MuiInputLabel-shrink"])': {
                transform: 'none',
            },
            // '& + .MuiInput-formControl': {
            '& + [class*="MuiInput-formControl"]': {
                marginTop: 0,
            },
        },
        // '& .MuiFormHelperText-root:not(.Mui-error)': {
        '& [class*="MuiFormHelperText-root"]:not([class*="Mui-error"])': {
            marginTop: -4,
            marginBottom: 1,
            fontWeight: 300,
            color: '#353535',
            fontStyle: 'italic',
        },
        '& [class*="MuiFormControlLabel-root"]': {
            marginBottom: 0,
        },
        '& input.rc-time-picker-input': {
            height: 40,
            color: '#000',
            lineHeight: 1,
            transition: 'none',
            
            '&[disabled]': {
                color: '#aaa',
            },
        },
        '& .rc-time-picker-panel': {
            paddingTop: 3,
            maxWidth: '100%',
            '& .rc-time-picker-panel-inner': {
                borderColor: '#3dbbe2',
                borderWidth: 2,
                '& .rc-time-picker-panel-select': {
                    width: '50%',
                    outline: 'none',
                },
            },
            '& .rc-time-picker-panel-input-wrap': {
                padding: '10px 11px 8px',
            },
            '& .rc-time-picker-panel-input': {
                fontSize: 16,
                lineHeight: 1,
                border: 0,
                fontFamily: ['Roboto','"Helvetica Neue"','sans-serif',].join(','),
            },
        },
        '& .rc-time-picker-clear': {
            top: 10,
        },
        '& .rc-time-picker-clear-icon:after': {
            fontSize: 18,
            color: 'hsl(0,0%,80%)',
        },
        // '& .MuiInput-input, & input.rc-time-picker-input': {
        '& [class*="MuiInput-input"], & input.rc-time-picker-input': {
            borderRadius: 4,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: (props) => (props['data-error'] ? ['#f44336', '!important'] : '#ced4da'),
            fontSize: 16,
            padding: '11px 12px 9px',
            outline: 'none',
            fontFamily: ['Roboto','"Helvetica Neue"','sans-serif',].join(','),
            '&:focus': {
                borderColor: '#3dbbe2',
                borderWidth: '2px',
                borderStyle: 'solid',
                padding: '10px 11px 8px',
            },
        },
        // '& .MuiCheckbox-root': {
        '& [class*="MuiCheckbox-root"]': {
            width: 'fit-content',
        },
        // '& .MuiInputBase-input': {
        '& [class*="MuiInputBase-input"]': {
            backgroundColor: '#fff',
        },
        '& .colorpicker': {
            borderRadius: 4,
            outline: 'none',
            padding: '11px 12px 9px',
            fontSize: '16',
            background: '#fff',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: (props) => (props['data-error'] ? ['#f44336', '!important'] : '#ced4da'),
            cursor: 'pointer',
            height: 40,
            textTransform: 'uppercase',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
        },
        '& .colorpicker-dot': {
            backgroundColor: '#ccc',
            borderRadius: 10,
            height: 10,
            width: 10,
            marginRight: 8,
        },
        '& .colorpicker-popover': {
            position: 'absolute',
            zIndex: 2,
            top: 57,
        },
        '& .colorpicker-popover-cover': {
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        '& .color-picker-clear': {
            marginLeft: 'auto',
        },
        // '& .MuiInputAdornment-positionEnd .MuiIconButton-root': {
        '& [class*="MuiInputAdornment-positionEnd"] [class*="MuiIconButton-root"]': {
            padding: 0,
        }
    },
}, { name: 'CustomFormControl' })(FormControl);